import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';

import { TechnologyProduct } from './filters/TechnologyProduct';
import { TechnologyVendor } from './filters/TechnologyVendor';
import { TechnologyVersion } from './filters/TechnologyVersion';

/**
 * Get simple filter definitions for Technology entity
 * Returns filter definitions for vendor, product, and version
 *
 * @returns Array of SimpleFilterDefinition
 */
export function getTechnologySimpleFilters(): SimpleFilterDefinition[] {
  return [TechnologyVendor, TechnologyProduct, TechnologyVersion];
}
